import type { ConfigDTO } from "../../common/types/ConfigDTO";
import type { UserDTO } from "../../common/types/UserDTO";
import { useAuthListener } from "./useAuthListener";
import { useDialogListener } from "./useDialogListener";
import { useVenueSelectionListener } from "./useVenueSelectionListener";

// Listen for messages from iFrame applications
export const useAppListeners = (user?: UserDTO, config?: ConfigDTO) => {
  useAuthListener(config);
  useVenueSelectionListener(user);

  const { dialogVisible } = useDialogListener();

  return { dialogVisible };
};
